<script setup>
// Animated "teammate is composing" bubble shown while we wait for a reply.
// Reusable for token streaming later: show this until the first token lands.
</script>

<template>
  <div :class="$style.row">
    <div
      :class="$style.bubble"
      role="status"
      aria-label="Arist Agent is typing"
    >
      <span :class="$style.dot" />
      <span :class="$style.dot" />
      <span :class="$style.dot" />
    </div>
  </div>
</template>

<style module>
.row {
  display: flex;
  justify-content: flex-start;
  padding: 0.25rem 0;
}
/* The typing bubble stands in for an agent (outgoing) message bubble, so it */
/* uses the same theme-aware chat tokens as ChatMessage — correct in dark mode */
.bubble {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.65rem 0.85rem;
  border-radius: 1rem;
  background: var(--bg-chat-message-outgoing);
}
.dot {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: var(--color-text-muted);
  animation: typing-blink 1.4s infinite both;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes typing-blink {
  0%, 80%, 100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}
</style>
